if (!customElements.get('card-swatch')) {
    customElements.define(
      'card-swatch',
      class CardSwatch extends HTMLElement {
        constructor() {
            super();
            this.swatches = this.querySelectorAll(".swatch");
            this.cardWrapper = this.closest(".card-wrapper");
            this.imagesContainer = this.cardWrapper.querySelector(".card__media div.media");
            this.originalImages = this.imagesContainer.querySelectorAll("img.original-card-image");
            this.hasAnyOriginalImage = this.originalImages?.length > 0;
            this.hasSecondaryImageForHover = this.originalImages?.length > 1;

            this.setEventlisteners();
        }

        setEventlisteners() {
            this.swatches.forEach((swatch) => {
                swatch.addEventListener("mouseenter", this.activateSwatch.bind(this));
            });
            this.addEventListener("mouseleave", this.deactiveAllActiveSwatches.bind(this));
        }

        activateSwatch(event){
            this.deactiveAllActiveSwatches();
            event.target.setAttribute("active", true);
            const dataContainer = event.target.closest(".card__swatch-swatch-wrapper");
            const containerData = dataContainer.dataset;
            const sanitizedDataset = this.sanitizeNeededDatasets(containerData);

            const objectEntries = Object.entries(sanitizedDataset);

            if(objectEntries.length === 0){
                return null;
            }

            let imageElement = this.imagesContainer.querySelector(`#${sanitizedDataset.id}`);
            if(!imageElement){
                imageElement = document.createElement("img");
                objectEntries.forEach(([attributeName, attributeValue]) => {
                    imageElement.setAttribute(`${attributeName}`, attributeValue)
                });
                imageElement = this.imagesContainer.appendChild(imageElement);
            }
            imageElement.setAttribute("active", true);
        }

        // deactivateSwatch(sanitizedDataset){
        //     const objectEntries = Object.entries(sanitizedDataset);

        //     if(objectEntries.length === 0){
        //         return null;
        //     }

        //     let imageElement = this.imagesContainer.querySelector(`#${sanitizedDataset.id}`);
        //     if(!imageElement){
        //         return null;
        //     }

        //     imageElement.setAttribute("active", false);
        //     return imageElement;
        // }

        deactiveAllActiveSwatches(){
            this.imagesContainer.querySelectorAll("img.swatch-card-image[active='true']").forEach((image) => {
                image.setAttribute("active", false);
            });
            this.swatches.forEach((swatch) => {
                swatch.removeAttribute("active");
            });
        }

        sanitizeNeededDatasets(dataset){
            return Object.keys(dataset).reduce((acc, key) => {
                if (key.startsWith("cardswatch")) {
                  acc[key.replace("cardswatch_", "")] = dataset[key];
                }
                return acc;
              }, {});
        }
      }
    );
  }